import { render, staticRenderFns } from "./map-label.vue?vue&type=template&id=8c493e9e&"
import script from "./map-label.vue?vue&type=script&lang=js&"
export * from "./map-label.vue?vue&type=script&lang=js&"
import style0 from "./map-label.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports